import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { getFormattedTime } from 'flow/utils';
import { selectTicketSortedTimestamp } from 'flow/selectors/TicketsSelectors';
import { TicketKey } from 'flow/types/EntityKeys';
import useAppContext from 'flow/hooks/useAppContext';

type Props = {
    ticketKey: TicketKey;
};

const SectionHeaderTime = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();

    const ticketTimestamp = useAppSelector((state) =>
        selectTicketSortedTimestamp(state, ticketKey),
    );

    return (
        <div className="text-sm whitespace-nowrap text-gray-500">
            {getFormattedTime(ticketTimestamp, i18next)}
        </div>
    );
};

export default React.memo(SectionHeaderTime);
